import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '@core/Services/event.service';
import { GTMService } from '@core/Services/gtm.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-leave-page',
  templateUrl: './leave-page.component.html',
  styleUrls: ['./leave-page.component.scss']
})
export class LeavePageComponent implements OnInit {

  @Input() redirect: any = '';
  content: any = '';

  target:any = ''


  timerInterval: any;
  countdown: number = 10;

  @Input() isRumahSaya:any;
  analytic:any;

  constructor(
    private modalController: ModalController,
    private eventService: EventService,
    private gtmService: GTMService,
    private router: Router
  ) {}

  ngOnInit() {


    if(this.redirect.includes('blibli.com') || this.redirect.includes('blib.li') || this.redirect.includes('blibli.onelink.me')){
      this.target = 'blibli'
    }

    if(this.redirect.includes('grab.com')){
      this.target = 'grab'
    }

    if(this.redirect.includes('grb.to')){
      this.target = 'grab'
    }



    this.startTimer();

  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }

  close() {
    this.modalController.dismiss();
    clearInterval(this.timerInterval);
  }

  goTo() {
    this.gtmService.GTMOutbondClick(this.redirect);

    //Jika ada data Analytic
    if(this.analytic){
        this.gtmService.sendTrackingGA('leadsengagement', this.analytic);
        this.gtmService.sendAnalyticDatalayer('view', 'leadsengagement', this.analytic).subscribe();
    }


    // window.open(this.redirect);

    // window.loca

    const aElem = document.createElement("a");
    aElem.href = this.redirect;
    aElem.target = "_blank";
    document.body.append(aElem);
    aElem.click();
    aElem.remove();

    clearInterval(this.timerInterval);


    this.modalController.dismiss();

  }

  goToTnc() {
    this.router.navigateByUrl('/tnc');
    this.modalController.dismiss();
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timerInterval);

        const aElem = document.createElement("a");
        aElem.href = this.redirect;
        aElem.target = "_blank";
        document.body.append(aElem);
        aElem.click();
        aElem.remove();

        setTimeout(() => {
          this.modalController.dismiss();
        }, 1000);
      }
    }, 1000);
  }

}
